/* NPFC GRAPHIC LANGUAGE
 * ---------------------------------------------------------------------------
 * Derived from SRC-001, the Tend A4 product card
 * (artefacts/source/identity-source-v1-20260908/source-evidence/A4-Productcard-Tend.pdf,
 *  sha256 1a710a7d41f779bf5653936ae6e07125f47f1bea15d038940334209f5fc42af9).
 * PROVENANCE: DERIVED_FROM_CLIENT_SOURCE_ARTWORK.
 * ------------------------------------------------------------------------- */

window.NPFC = window.NPFC || (() => {
  const NS = 'http://www.w3.org/2000/svg';
  const R = (n, d = 2) => Number(n.toFixed(d));

  function el(name, attrs = {}) {
    const n = document.createElementNS(NS, name);
    for (const k in attrs) n.setAttribute(k, attrs[k]);
    return n;
  }

  function svg(vb, attrs = {}) {
    return el('svg', { viewBox: vb, xmlns: NS, ...attrs });
  }

  function petalPath(len, wid) {
    const w = wid / 2;
    return `M 0 0 C ${w * 0.9} ${-len * 0.18} ${w} ${-len * 0.55} 0 ${-len} C ${-w} ${-len * 0.55} ${-w * 0.9} ${-len * 0.18} 0 0 Z`;
  }

  function frond({ colour, petals = 6, spread = 118, len = 46, wid = 17, taper = 0.62, rotate = 0 } = {}) {
    const g = el('g', { transform: `rotate(${rotate})` });
    const step = spread / (petals - 1);
    const start = -spread / 2;
    for (let i = 0; i < petals; i++) {
      const t = i / (petals - 1);
      const scale = 1 - Math.abs(t - 0.5) * 2 * (1 - taper);
      g.appendChild(el('path', {
        d: petalPath(R(len * scale), R(wid * scale)),
        fill: colour,
        transform: `rotate(${R(start + step * i)})`,
      }));
    }
    return g;
  }

  function rosette({ spokeColour, coreColour, ringColour, spokes = 26, r0 = 20, r1 = 33, coreR = 17 } = {}) {
    const g = el('g');
    for (let i = 0; i < spokes; i++) {
      const a = (360 / spokes) * i;
      g.appendChild(el('rect', {
        x: R(-1.9), y: R(-r1), width: R(3.8), height: R(r1 - r0 + 2),
        rx: 1.9, fill: spokeColour,
        transform: `rotate(${R(a)})`,
      }));
    }
    g.appendChild(el('circle', { r: R(r0), fill: 'none', stroke: ringColour, 'stroke-width': 1.4 }));
    g.appendChild(el('circle', { r: R(coreR), fill: coreColour }));
    return g;
  }

  function ring({ ringColour, coreColour, outer = 44, inner = 30, coreR = 21 } = {}) {
    const g = el('g');
    g.appendChild(el('circle', { r: R(outer), fill: ringColour }));
    g.appendChild(el('circle', { r: R(inner), fill: 'var(--ground)' }));
    if (coreColour) g.appendChild(el('circle', { r: R(coreR), fill: coreColour }));
    return g;
  }

  function leafTile({ a, b, size = 96, corner = 'tl-br' } = {}) {
    const s = size, g = el('g');
    const d = corner === 'tl-br'
      ? `M 0 ${s} L 0 ${s / 2} A ${s / 2} ${s / 2} 0 0 1 ${s / 2} 0 L ${s} 0 L ${s} ${s / 2} A ${s / 2} ${s / 2} 0 0 1 ${s / 2} ${s} Z`
      : `M ${s} ${s} L ${s / 2} ${s} A ${s / 2} ${s / 2} 0 0 1 0 ${s / 2} L 0 0 L ${s / 2} 0 A ${s / 2} ${s / 2} 0 0 1 ${s} ${s / 2} Z`;
    const clipId = 'lt' + Math.random().toString(36).slice(2, 8);
    const cp = el('clipPath', { id: clipId });
    cp.appendChild(el('path', { d }));
    g.appendChild(cp);
    const inner = el('g', { 'clip-path': `url(#${clipId})` });
    inner.appendChild(el('path', { d: `M 0 0 L ${s} ${s} L 0 ${s} Z`, fill: a }));
    inner.appendChild(el('path', { d: `M 0 0 L ${s} ${s} L ${s} 0 Z`, fill: b }));
    g.appendChild(inner);
    return g;
  }

  function dotFlower({ petalColour, coreColour, n = 6, orbit = 26, petalR = 15, coreR = 8 } = {}) {
    const g = el('g');
    for (let i = 0; i < n; i++) {
      const a = (Math.PI * 2 / n) * i - Math.PI / 2;
      g.appendChild(el('circle', {
        cx: R(Math.cos(a) * orbit), cy: R(Math.sin(a) * orbit), r: R(petalR), fill: petalColour,
      }));
    }
    if (coreColour) g.appendChild(el('circle', { r: R(coreR), fill: coreColour }));
    return g;
  }

  function quarterField({ colour, size = 80, rot = 0 } = {}) {
    const g = el('g', { transform: `rotate(${rot})` });
    g.appendChild(el('path', { d: `M ${-size / 2} ${size / 2} L ${-size / 2} ${-size / 2} A ${size} ${size} 0 0 1 ${size / 2} ${size / 2} Z`, fill: colour }));
    return g;
  }

  function halfDisc({ colour, r = 46, rot = 0 } = {}) {
    const g = el('g', { transform: `rotate(${rot})` });
    g.appendChild(el('path', { d: `M ${-r} 0 A ${r} ${r} 0 0 1 ${r} 0 Z`, fill: colour }));
    return g;
  }

  function fan({ colour, spokes = 15, spread = 150, r0 = 8, r1 = 40 } = {}) {
    const g = el('g');
    const step = spread / (spokes - 1);
    for (let i = 0; i < spokes; i++) {
      g.appendChild(el('rect', {
        x: -1.3, y: R(-r1), width: 2.6, height: R(r1 - r0), rx: 1.3, fill: colour,
        transform: `rotate(${R(-spread / 2 + step * i)})`,
      }));
    }
    return g;
  }

  const icons = {
    petalCross: (a, b) => {
      const g = el('g');
      [0, 90, 180, 270].forEach((rot, i) => {
        g.appendChild(el('path', {
          d: petalPath(15, 9), fill: i % 2 ? b : a,
          transform: `translate(16,16) rotate(${rot + 45})`,
        }));
      });
      return g;
    },
    tulip: (a, b) => {
      const g = el('g');
      g.appendChild(el('path', { d: 'M 6 17 A 10 10 0 0 1 26 17 L 26 24 A 3 3 0 0 1 23 27 L 9 27 A 3 3 0 0 1 6 24 Z', fill: a }));
      g.appendChild(el('path', { d: petalPath(13, 8), fill: b, transform: 'translate(11.5,17) rotate(-20)' }));
      g.appendChild(el('path', { d: petalPath(13, 8), fill: b, transform: 'translate(20.5,17) rotate(20)' }));
      return g;
    },
    blossom: (a, b) => {
      const g = el('g', { transform: 'translate(16,16)' });
      for (let i = 0; i < 6; i++) {
        g.appendChild(el('path', { d: petalPath(13, 9), fill: a, transform: `rotate(${i * 60})` }));
      }
      g.appendChild(el('circle', { r: 3.6, fill: b }));
      return g;
    },
    soil: (a, b) => {
      const g = el('g');
      g.appendChild(el('path', { d: 'M 3 25 A 13 13 0 0 1 29 25 Z', fill: a }));
      [[9, 13], [16, 9.5], [23, 13]].forEach(([cx, cy], i) =>
        g.appendChild(el('circle', { cx, cy, r: i === 1 ? 3.4 : 2.6, fill: b })));
      g.appendChild(el('rect', { x: 2, y: 25, width: 28, height: 3.4, rx: 1.7, fill: a }));
      return g;
    },
    target: (a, b) => {
      const g = el('g', { transform: 'translate(16,16)' });
      g.appendChild(el('circle', { r: 13, fill: a }));
      g.appendChild(el('circle', { r: 8.5, fill: 'var(--paper)' }));
      g.appendChild(el('circle', { r: 5.5, fill: b }));
      return g;
    },
  };

  function patternField(node, { w = 1200, h = 320, ground, palette, density = 1, seed = 7 } = {}) {
    let s = seed;
    const rnd = () => (s = (s * 1103515245 + 12345) % 2147483648) / 2147483648;
    const pick = arr => arr[Math.floor(rnd() * arr.length)];
    const root = svg(`0 0 ${w} ${h}`, { class: 'npfc-field', preserveAspectRatio: 'xMidYMid slice' });
    root.appendChild(el('rect', { width: w, height: h, fill: ground }));
    const cell = 108;
    const cols = Math.ceil(w / cell), rows = Math.ceil(h / cell);
    for (let y = 0; y < rows; y++) {
      for (let x = 0; x < cols; x++) {
        if (rnd() > 0.86 * density) continue;
        const cx = x * cell + cell / 2, cy = y * cell + cell / 2;
        const c1 = pick(palette), c2 = pick(palette.filter(c => c !== c1));
        const kind = Math.floor(rnd() * 7);
        let shape;
        if (kind === 0) shape = frond({ colour: c1, petals: 5 + Math.floor(rnd() * 3), rotate: rnd() * 360, len: 34 + rnd() * 14 });
        else if (kind === 1) shape = rosette({ spokeColour: c1, ringColour: c1, coreColour: c2, spokes: 22 + Math.floor(rnd() * 8), r0: 16, r1: 28, coreR: 14 });
        else if (kind === 2) shape = ring({ ringColour: c1, coreColour: c2, outer: 30 + rnd() * 12, inner: 22 + rnd() * 6, coreR: 15 });
        else if (kind === 3) shape = dotFlower({ petalColour: c1, coreColour: c2, n: 6, orbit: 22, petalR: 12, coreR: 7 });
        else if (kind === 4) shape = halfDisc({ colour: c1, r: 36 + rnd() * 12, rot: Math.floor(rnd() * 4) * 90 });
        else if (kind === 5) shape = quarterField({ colour: c1, size: 62, rot: Math.floor(rnd() * 4) * 90 });
        else shape = fan({ colour: c1, spokes: 13, spread: 140, r0: 6, r1: 32 });
        shape.setAttribute('transform', `translate(${R(cx)},${R(cy)}) ${shape.getAttribute('transform') || ''}`);
        root.appendChild(shape);
      }
    }
    node.appendChild(root);
    return root;
  }

  function bottle(node, { body = '#FFFFFF', cap, label, name = '', sub = '', shadow = true } = {}) {
    const root = svg('0 0 120 264', { class: 'npfc-bottle' });
    if (shadow) root.appendChild(el('ellipse', { cx: 60, cy: 254, rx: 40, ry: 7, fill: 'rgba(0,0,0,.14)' }));
    root.appendChild(el('rect', { x: 45, y: 6, width: 30, height: 26, rx: 5, fill: cap || label }));
    root.appendChild(el('rect', { x: 49, y: 28, width: 22, height: 16, fill: body }));
    root.appendChild(el('path', {
      d: 'M 49 40 C 49 56 22 60 22 92 L 22 232 A 16 16 0 0 0 38 248 L 82 248 A 16 16 0 0 0 98 232 L 98 92 C 98 60 71 56 71 40 Z',
      fill: body,
    }));
    root.appendChild(el('rect', { x: 26, y: 104, width: 68, height: 104, rx: 6, fill: label }));
    const fit = (txt, y, size, fill, max) => {
      const n = el('text', {
        x: 60, y, 'text-anchor': 'middle', fill,
        style: `font:${size} system-ui,sans-serif; letter-spacing:-.02em`,
      });
      n.textContent = txt;
      if (txt.length > max) {
        n.setAttribute('textLength', 60);
        n.setAttribute('lengthAdjust', 'spacingAndGlyphs');
      }
      return n;
    };
    root.appendChild(fit(name, 142, '700 20px/1', '#fff', 9));
    root.appendChild(fit(sub, 164, '600 10px/1', 'rgba(255,255,255,.88)', 18));
    root.appendChild(el('rect', { x: 38, y: 178, width: 44, height: 3, rx: 1.5, fill: 'rgba(255,255,255,.5)' }));
    root.appendChild(el('rect', { x: 46, y: 186, width: 28, height: 3, rx: 1.5, fill: 'rgba(255,255,255,.35)' }));
    node.appendChild(root);
    return root;
  }

  function plant(node, { stem, leafA, leafB, bloom, pot } = {}) {
    const root = svg('0 0 240 300', { class: 'npfc-plant' });
    const potG = el('g', { class: 'pot' });
    potG.appendChild(el('path', { d: 'M 74 236 L 166 236 L 156 292 A 8 8 0 0 1 148 299 L 92 299 A 8 8 0 0 1 84 292 Z', fill: pot }));
    potG.appendChild(el('rect', { x: 68, y: 222, width: 104, height: 20, rx: 8, fill: pot }));
    const growth = el('g', { class: 'growth' });
    const stemPath = el('path', {
      class: 'stem',
      d: 'M 120 232 C 120 196 118 168 120 140 C 122 112 119 88 120 62',
      fill: 'none', stroke: stem, 'stroke-width': 7, 'stroke-linecap': 'round',
    });
    growth.appendChild(stemPath);
    const leaves = [
      { y: 200, rot: -58, scale: 1.0, fill: leafA, at: 0.18 },
      { y: 178, rot: 62, scale: 0.92, fill: leafB, at: 0.32 },
      { y: 150, rot: -66, scale: 0.86, fill: leafB, at: 0.48 },
      { y: 128, rot: 68, scale: 0.8, fill: leafA, at: 0.62 },
      { y: 100, rot: -60, scale: 0.7, fill: leafA, at: 0.76 },
    ];
    leaves.forEach((lf, i) => {
      const g = el('g', { class: 'leaf', 'data-at': lf.at, transform: `translate(120,${lf.y}) rotate(${lf.rot}) scale(${lf.scale})` });
      g.appendChild(el('path', { d: petalPath(58, 30), fill: lf.fill, transform: 'rotate(90)' }));
      growth.appendChild(g);
    });
    const bloomG = el('g', { class: 'bloom', 'data-at': 0.88, transform: 'translate(120,58)' });
    for (let i = 0; i < 8; i++) bloomG.appendChild(el('path', { d: petalPath(26, 15), fill: bloom, transform: `rotate(${i * 45})` }));
    bloomG.appendChild(el('circle', { r: 8, fill: leafA }));
    growth.appendChild(bloomG);
    root.appendChild(growth);
    root.appendChild(potG);
    node.appendChild(root);
    return {
      root,
      set(v) {
        const g = Math.max(0, Math.min(1, v));
        root.style.setProperty('--grow', g);
        const len = stemPath.getTotalLength();
        stemPath.style.strokeDasharray = len;
        stemPath.style.strokeDashoffset = len * (1 - Math.min(1, g * 1.05));
        root.querySelectorAll('.leaf, .bloom').forEach(n => {
          const at = parseFloat(n.dataset.at);
          const t = Math.max(0, Math.min(1, (g - at) / 0.16));
          n.style.opacity = t;
          n.style.transform = n.getAttribute('transform') + ` scale(${0.4 + t * 0.6})`;
        });
      },
    };
  }

  function tractor(node, { body, wheel, hub, accent, cab } = {}) {
    const root = svg('0 0 340 190', { class: 'npfc-tractor' });
    const g = el('g');
    g.appendChild(el('path', { d: 'M 6 92 L 92 92 L 82 138 L 20 138 Z', fill: accent }));
    g.appendChild(el('rect', { x: 6, y: 84, width: 86, height: 11, rx: 5, fill: hub }));
    g.appendChild(el('rect', { x: 88, y: 120, width: 34, height: 8, rx: 4, fill: body }));
    g.appendChild(el('path', {
      d: 'M 150 128 A 46 46 0 0 1 242 128 L 230 128 A 34 34 0 0 0 162 128 Z', fill: body,
    }));
    g.appendChild(el('rect', { x: 120, y: 100, width: 130, height: 34, rx: 7, fill: body }));
    g.appendChild(el('rect', { x: 246, y: 92, width: 66, height: 36, rx: 8, fill: body }));
    g.appendChild(el('rect', { x: 250, y: 100, width: 12, height: 10, rx: 3, fill: hub }));
    g.appendChild(el('circle', { cx: 306, cy: 104, r: 7, fill: '#FFE9A8' }));
    g.appendChild(el('path', {
      d: 'M 176 100 L 176 52 A 9 9 0 0 1 185 43 L 232 43 A 9 9 0 0 1 241 52 L 241 100 Z', fill: body,
    }));
    g.appendChild(el('rect', { x: 185, y: 53, width: 48, height: 32, rx: 5, fill: cab || accent }));
    g.appendChild(el('rect', { x: 172, y: 96, width: 74, height: 8, rx: 4, fill: hub }));
    g.appendChild(el('rect', { x: 252, y: 56, width: 11, height: 40, rx: 5, fill: hub }));
    const puff = el('g', { class: 'puff' });
    [[258, 44, 7], [266, 30, 5.5], [274, 19, 4]].forEach(([cx, cy, r], i) => {
      const c = el('circle', { cx, cy, r, fill: 'rgba(255,255,255,.5)' });
      c.setAttribute('style', `--i:${i}`);
      puff.appendChild(c);
    });
    g.appendChild(puff);
    const mkWheel = (cx, cy, r) => {
      const w = el('g', { class: 'wheel' });
      w.appendChild(el('circle', { cx, cy, r, fill: wheel }));
      w.appendChild(el('circle', { cx, cy, r: r * 0.52, fill: hub }));
      w.appendChild(el('circle', { cx, cy, r: r * 0.16, fill: wheel }));
      for (let i = 0; i < 8; i++) {
        w.appendChild(el('rect', {
          x: cx - 2.4, y: cy - r * 0.95, width: 4.8, height: r * 0.42, rx: 2.4, fill: hub,
          transform: `rotate(${i * 45} ${cx} ${cy})`,
        }));
      }
      for (let i = 0; i < 12; i++) {
        w.appendChild(el('rect', {
          x: cx - 3, y: cy - r, width: 6, height: 7, rx: 2, fill: hub,
          transform: `rotate(${i * 30} ${cx} ${cy})`,
        }));
      }
      return w;
    };
    g.appendChild(mkWheel(196, 132, 44));
    g.appendChild(mkWheel(288, 146, 28));
    root.appendChild(g);
    node.appendChild(root);
    return root;
  }

  function fieldSky(node, { cloud = 'rgba(255,255,255,.10)', bird = 'rgba(255,255,255,.34)' } = {}) {
    const root = svg('0 0 1440 200', { class: 'npfc-sky', preserveAspectRatio: 'xMidYMid slice' });
    const puffCloud = (x, y, s) => {
      const c = el('g', { class: 'cloud', transform: `translate(${x},${y}) scale(${s})` });
      [[0, 0, 26], [26, -8, 20], [50, 2, 16], [-22, 4, 17]].forEach(([cx, cy, r]) =>
        c.appendChild(el('circle', { cx, cy, r, fill: cloud })));
      return c;
    };
    [[180, 46, 1], [720, 34, .78], [1160, 54, 1.14]].forEach(([x, y, s], i) => {
      const c = puffCloud(x, y, s);
      c.setAttribute('style', `--d:${i * 9}s`);
      root.appendChild(c);
    });
    [[980, 40], [1016, 30]].forEach(([x, y], i) => {
      const b = el('path', {
        d: `M ${x} ${y} q 8 -7 16 0 q 8 -7 16 0`, fill: 'none', stroke: bird,
        'stroke-width': 2.6, 'stroke-linecap': 'round', class: 'bird',
      });
      b.setAttribute('style', `--d:${i * 1.4}s`);
      root.appendChild(b);
    });
    node.appendChild(root);
    return root;
  }

  return { el, svg, petalPath, bottle, fieldSky, frond, rosette, ring, leafTile, dotFlower, quarterField, halfDisc, fan, icons, patternField, plant, tractor };
})();
